import Icon from '../components/Icon.vue'

Icon.register({
  cloud: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M537.6 226.6C541.7 215.9 544 204.2 544 192 544 139 501 96 448 96 428.3 96 409.9 102 394.7 112.2 367 64.2 315.3 32 256 32 167.6 32 96 103.6 96 192 96 194.7 96.1 197.4 96.2 200.1 40.2 219.8 0 273.2 0 336 0 415.5 64.5 480 144 480H512C582.7 480 640 422.7 640 352 640 290.1 596 238.4 537.6 226.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud.js
// module id = HOA6
// module chunks = 144